import Vue from "vue";

import "./styles/quasar.scss";
import "quasar/dist/quasar.ie.polyfills";
import { Quasar, QBtn, QIcon, QList, QItem, QItemLabel } from "quasar";

//isoName overwrite for correct language selector display
import langEn from 'quasar/lang/en-us';

if(document && document.documentElement && document.documentElement.lang){
  langEn.isoName = document.documentElement.lang;
}


Vue.use(Quasar, {
  config: {},
  components: {
    QBtn,
    QIcon,
    QList,
    QItem,
    QItemLabel
  },
  lang: langEn,
  directives: {}
});
